<script setup lang="ts">
import { CategoryPills } from '~/components/ui/category-pills'
import type { ICreditTypes } from '~/components/widget/select-credit-type'
import type { IResponseData } from '~/types'

// Same request and key as WidgetSelectCreditType, so the pills mirror the sidebar menu
// and the request is shared with it
const url = useUrlWithParams('/credit_types', { 'filter[position]': 'sidebar' })
const { data: creditTypesData } = await useApi<IResponseData<ICreditTypes[]>>(() => url, {
  key: 'credit-types-sidebar-widget'
})

const items = computed(
  () =>
    creditTypesData.value?.data.map((type) => ({
      title: type.title,
      url: `/credits/${type.slug}`,
      icon: type.slug
    })) ?? []
)
</script>

<template>
  <CategoryPills :items="items" :sheet-title="$t('common.loan_selection')" />
</template>
